import React, { useEffect, useState } from 'react';
import { FlatList, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from '../../../globalComponents/NativeOverrides';
import { social_bulkGetArticles } from '../../../store/actionsv1/social';
import { ArticleProps } from '../../../store/types/soc_svc';
import ArticleWidget from '../articles/ArticleWidget';
import ArticleCard from './ArticleCard';


type PostArticleHolderProps = {
    article_ids:string[],
    width:number
}
const PostArticleHolder = ({ article_ids, width }:PostArticleHolderProps) => {
    const [ loading, setLoading ] = useState(false);

    const dispatch = useDispatch();

    const articles_list:{updated:number, articles:ArticleProps[]} = useSelector((state:any) => state.social.articles_list, (left, right) => left.updated == right.updated)
    const articles = articles_list.articles.filter(a => article_ids.map(id => id.toString()).includes(a.article_id.toString()));
    
    useEffect(() => {
        if(article_ids.length == 0){ return }
        getArticlesFromServer(article_ids)
    },[])

    const getArticlesFromServer = async(article_ids:string[]) => {
        setLoading(true);
        await dispatch(social_bulkGetArticles(article_ids))
        setLoading(false);
    }

    const renderArticles = (data:{ item:ArticleProps, index:number }) => {
        return (
            <ArticleWidget
                article_id={data.item.article_id}
                width={width}
            />
        )
    }

    if(articles.length == 0){ return <></> }
    return (
        <View>
            <FlatList
                listKey='articles'
                keyExtractor={(item) => item.article_id.toString()}
                data={articles}
                renderItem={renderArticles}
            />
        </View>
    )
}

export default PostArticleHolder